import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

interface StepperItem {
  name: string;
  icon: string;
}

@Component({
  selector: 'np-stepper',
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.css'
})
export class StepperComponent implements AfterViewInit {
  @ViewChild('stepper', { static: false }) stepper: ElementRef<HTMLDivElement>;

  @Input() name: string = '';
  @Input() steps: StepperItem[] = [];
  @Input() buttonWidth: number = 150;
  @Output() onStepChange = new EventEmitter<string>();
  currentStep = 0;

  ngAfterViewInit(): void {
    if (this.steps.length > 0) {
      this.stepper.nativeElement.style.setProperty('--stepper-btn-width', `${this.buttonWidth}px`);
      this.stepper.nativeElement.style.setProperty('--stepper-steps', this.steps.length.toString());
    }
  }

  selectStage(step: StepperItem) {
    this.onStepChange.emit(step.name);
  }

}
